






















import Component from 'vue-class-component';
import Vue from 'vue';
import DataLoggerAutocomplete
  from '@/general/component/form/autocomplete/DataLoggerAutcomplete.vue';
import FacilityAutocomplete from '@/general/component/form/autocomplete/FacilityAutocomplete.vue';
import TextInput from '@/general/component/form/input/TextInput.vue';
import {VModel} from 'vue-property-decorator';
import {DataLoggerFormModel} from '@/context/data_logger/model/form/DataLoggerFormModel';
import {required} from '@/common/validation/validation';
import DataLoggerVersionAutocomplete
  from "@/general/component/form/autocomplete/DataLoggerVersionAutocomplete.vue";
import {dataLoggerApi} from '@/context/data_logger/api/DataLoggerApi';

@Component({
  components: {
    DataLoggerVersionAutocomplete,
    DataLoggerAutocomplete,
    FacilityAutocomplete,
    TextInput
  }
})
export default class DataLoggerFormTemplate extends Vue {
  @VModel({type: Object}) model!: DataLoggerFormModel;
  valid = true;
  identifierErrors: string[] = [];

  get rules(): Record<string, unknown> {
    return {
      facility: [required],
      identifier: [required]
    };
  }

  async onBlurIdentifier(): Promise<void> {
    const value = this.model.identifier;
    if (!value) {
      this.identifierErrors = [];
      return;
    }
    try {
      const result = await dataLoggerApi.validateIdentifierUnique(value, this.model.id);
      this.identifierErrors = result.unique ? [] : [result.message];
    } catch {
      this.identifierErrors = [];
    }
  }
}
